import React, { useEffect, useState } from 'react'
import PeriodicityTabs from './PeriodicityTabs'
import PeriodicityRiskComponent from './PeriodicityRiskComponent'
import { calculateDaysAgo } from 'src/lib/utils'

export default function PeriodicityComponent ({ type, getData, setDaysAgo }) {
    const [ data, setData ] = useState([])
    const [ selectedTab, setSelectedTab ] = useState(0)
    const [ selectedData, setSelectedData ] = useState({})
    useEffect(() => {
        setData(getData)
        setSelectedData(getData[getData.length - 1])
        setSelectedTab(getData.length - 1)
    }, [getData])
    useEffect(() => {
        const currentDate = new Date()
        const somePastDate = typeof selectedData?.createdAt === 'string' ? new Date(selectedData?.createdAt) : selectedData?.createdAt
        setDaysAgo(calculateDaysAgo(currentDate, somePastDate))
    }, [selectedData])
    return (
        <>
            <PeriodicityTabs type={type} selectedTab={selectedTab} setSelectedData={setSelectedData} setSelectedTab={setSelectedTab} data={data} />
            <PeriodicityRiskComponent type={type} data={selectedData} />
        </>
    )
}
